import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ButtonClickAsyncEvent } from "src/app/components/ui/button/button-click-async-event";

@Component({
  selector: "page-edit-action",
  template: "",
  standalone: false
})
export class PageEditActionComponent {
  @Input()
  title: string = "";

  @Input()
  type: "primary" | "default" | "text" | "outlined" = "default";

  @Input()
  icon: string | undefined;

  @Input()
  enabledOnlyIfDirty: boolean = false;

  @Output()
  onClick: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  onClickAsync: EventEmitter<ButtonClickAsyncEvent> =
    new EventEmitter<ButtonClickAsyncEvent>();
}
